/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { AuthenticationService } from '../../common/authentication/service/AuthenticationService';
import { PjInjectProxy } from '../../common/extends_fw/PjInjectProxy';
import { PjBaseController, Alert } from '../../common/extends_fw/controller/PjBaseController';
import { PjServiceResponse } from '../../common/extends_fw/service/PjServiceResponse';
import { MsgLevel } from '../../framework/controller/MsgLevel';
import { HeaderService } from '../service/HeaderService';
import { UserEditJson } from '../json/JsonAll';
import { SharedService } from '../../common/extends_fw/controller/PjBaseController';

/**
 * 会社画面について出力処理およびイベント処理を行う。
 */
export class HeaderController extends PjBaseController {

    // ユーザ名
    public userName: string;

    // 会社名
    public companyName: string;

    // ユーザ情報
    public userInfo: any;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $window: ng.IWindowService,
            protected $uibModal: ng.ui.bootstrap.IModalService,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected headerService: HeaderService,
            protected $location: ng.ILocationService,
            protected sharedService: SharedService,
            protected $scope: any) {
        super($stateParams, $translate, $location, pjInjectProxy);

        //  項目の表示制御
        $scope.tohmatsu = this.isTohmatsu();
        $scope.companyMana = !this.isTohmatsu();

        //  sharedService
        let auth: any;

        auth = sharedService.get('auth');
        if (auth) {
            this.userName = auth.userName || '';
            this.companyName = auth.companyName || '';
        }

        pjInjectProxy.$rootScope.$on('change_authinfo', (event, args): void => {
            this.go('/top');
        });
    }

    /**
     * ロケーション切替イベント
     */
    public go(url: string): void {
        this.$location.url('/blank' + url);

        //  項目の表示制御
        this.$scope.tohmatsu = this.isTohmatsu();
        this.$scope.companyMana = !this.isTohmatsu();

        //  sharedService
        let auth: any;

        auth = this.sharedService.get('auth');
        if (auth) {
            this.userName = auth.userName || '';
            this.companyName = auth.companyName || '';
        }
    };

    /**
     * Logoutイベント
     */
    public logout(): void {
        this.headerService.logout().then((data: any) => {
            // ユーザ切替時のlogoutはdataが返る
            // 通常のlogoutはブランクのdataが返る
            if (Object.keys(data.data).length !== 0) {
                this.userInfo = data.data.user;
                this.sharedService.set('auth',
                    {role: parseInt(this.userInfo.role), userId: this.userInfo.userId, userName: this.userInfo.userName, companyId: this.userInfo.companyId, companyName: this.userInfo.companyName});
                this.go('/top');
            } else {
                this.sharedService.set('auth', {});
                this.$location.url('/');
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    };

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/controller/HeaderController.ts
 **/